import signalr from 'BASE/common/signalrAdapter';
import { actionTypes } from 'BASE/store/types';
import chat from 'SKYXH/views/Chat/Chat';
import BetAwardNotifyComponent from 'BASE/components/notification/betAwardNotify.component';
import websiteInfoUtil from 'BASE/common/util/util.websiteInfo';
import userInfo_component from 'BASE/components/userInfo.component';
import afk from 'BASE/components/downLoad/AFK';
import top_header_component from 'SKYXH/views/TopHeader';
import announcement_component from 'SKYXH/views/Announcement';
import { browser } from 'BASE/common/util/util.browser';
import IEAlertComponent from 'SKYXH/views/IEAlert.vue';
import left_menu_component from 'SKYXH/views/LeftMenu';

export default {
    data: function () {
        return {
            minHeight: 600,
        };
    },
    mixins: [websiteInfoUtil, userInfo_component, afk],
    components: {
        chat,
        BetAwardNotifyComponent,
        top_header_component,
        left_menu_component,
        announcement_component,
        IEAlertComponent,
    },
    computed: {
        isLogin() {
            return (this.$store.state.userinfo.isLogin && this.$store.state.userinfo.greetings);
        }
    },
    watch: {
        '$route.path': function (val, oldVal) {
            // 投注頁body使用特定class
            let _betBackgroundClass = ['/Bet', '/MultiBet'];
            if (_betBackgroundClass.find((item) => val.indexOf(item) != -1)) {
                document.body.className = 'gray-bg';
            } else {
                document.body.className = '';
            }
        },
    },
    methods: {
        resizeContent() {
            let _header = this.isLogin && $('header').is(':visible') ? $('header').outerHeight() : 0;
            let _footer = this.isLogin && $('footer').is(':visible') ? $('footer').outerHeight() : 0;
            if (typeof _header === 'undefined') _header = 0;

            if (typeof _footer === 'undefined') _footer = 0;

            this.minHeight = $(window).height() - _header - _footer;
        },
        async refreshAmount() {
            await this.$store.dispatch(actionTypes.USER_INFO_WALLET_AMOUNT);
        },
        showAnnouncement(id, index) {
            if (this.$refs && this.$refs.Announcement) {
                this.$refs.Announcement.showAnnouncement(id, index);
            }
        },
    },
    created() {
        signalr.init();
    },
    updated() {
        this.resizeContent();
    },
    mounted() {
        if (browser.isIE) this.$refs.ieAlert.showDialog();

        let _this = this;
        //先執行一次變更內容區最小高度，綁定視窗變更事件
        this.resizeContent();
        window.addEventListener('resize', () => _this.resizeContent());
    },
};
